import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { reactive, ref } from 'vue';
import { useAuthorStore } from '@/stores';
import { modal } from '@/share/components';

import { getAPI } from '/Users/ytx/ytx/projects/jxpj/web/jxpj-client/src/server/auto-import.js';
export default {
  __name: 'change-self-pwd-form',
  setup(__props, {
    expose: __expose
  }) {
    const formRef = ref();
    const authorStore = useAuthorStore();
    const verifyPassword = getAPI('user.verifyPassword');
    const setSelfPwd = getAPI('user.setSelfPwd');
    const formData = reactive({
      password: '',
      oldPassword: '',
      passwordConfirm: ''
    });
    const rules = {
      oldPassword: [{
        required: true,
        message: '旧密码不能为空',
        trigger: 'blur'
      }],
      password: [{
        required: true,
        message: '密码不能为空',
        trigger: 'blur'
      }, {
        validator: async ({
          itemValue
        }) => {
          if (!itemValue) return Promise.reject(new Error('密码不能为空'));
          const {
            error
          } = await verifyPassword({
            userId: authorStore.userId,
            password: itemValue
          });
          if (error) return Promise.reject(new Error(error));
          return Promise.resolve();
        }
      }],
      passwordConfirm: [{
        required: true,
        message: '密码确认不能为空',
        trigger: 'blur'
      }, {
        validator: async ({
          itemValue,
          data
        }) => {
          if (!itemValue) return Promise.reject(new Error('密码确认不能为空'));
          if (itemValue !== data.password) {
            return Promise.reject(new Error('两次输入的密码不一致'));
          }
          return Promise.resolve();
        }
      }]
    };
    const validate = async () => {
      const $form = formRef.value;
      if (!$form) return Promise.resolve(false);
      const errors = await $form.validate();
      if (errors) return Promise.resolve(false);
      return Promise.resolve(true);
    };
    const submit = async () => {
      const valid = await validate();
      if (!valid) return Promise.resolve(false);
      const {
        password,
        oldPassword
      } = formData;
      const {
        error
      } = await setSelfPwd({
        password,
        oldPassword
      });
      if (error) {
        modal.notification.error(error);
        return Promise.resolve(false);
      }
      return Promise.resolve(true);
    };
    __expose({
      confirmListener() {
        return submit();
      }
    });
    return (_ctx, _cache) => {
      const _component_vxe_password_input = _resolveComponent("vxe-password-input");
      const _component_vxe_form_item = _resolveComponent("vxe-form-item");
      const _component_vxe_form = _resolveComponent("vxe-form");
      return _openBlock(), _createBlock(_component_vxe_form, {
        ref_key: "formRef",
        ref: formRef,
        data: formData,
        rules: rules,
        "title-width": 110,
        "title-align": "right",
        "title-colon": true
      }, {
        default: _withCtx(() => [_createVNode(_component_vxe_form_item, {
          span: "24",
          field: "oldPassword",
          title: "旧密码"
        }, {
          default: _withCtx(() => [_createVNode(_component_vxe_password_input, {
            modelValue: formData.oldPassword,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => formData.oldPassword = $event)
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_vxe_form_item, {
          span: "24",
          field: "password",
          title: "新密码"
        }, {
          default: _withCtx(() => [_createVNode(_component_vxe_password_input, {
            modelValue: formData.password,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => formData.password = $event)
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_vxe_form_item, {
          span: "24",
          field: "passwordConfirm",
          title: "密码确认"
        }, {
          default: _withCtx(() => [_createVNode(_component_vxe_password_input, {
            modelValue: formData.passwordConfirm,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => formData.passwordConfirm = $event)
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"]);
    };
  }
};